<template>
    <p class='opc-succezz__subtitle__desc' v-html='subTitle'></p>
</template>

<script>
export default {
  props: {
    subTitle: String
  }
}
</script>

<style lang="scss">
  .opc-succezz__subtitle__desc {
    font-family: Almaden Sans;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 6px;
    margin-bottom: 24px;
  }
</style>
